export default __webpack_public_path__ + "static/media/spotify.6f347287.svg";